import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthorization } from '@/stores/AuthorizationStore'

const routes: Array<RouteRecordRaw> = [
    {
        path: '',
        name: 'rechargeLayout',
        component: () => import("@/layouts/clientLayout.vue"),
        children: [
            {
                path: '',
                name: 'dashBoard',
                component: () => import('@/modules/dashBoard/view/dashBoard.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/Calls',
                name: 'Calls',
                component: () => import('@/modules/calls/view/callsTemplate.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/maintenance',
                name: 'Mtto',
                component: () => import('@/modules/mtto/view/mttoTemplate.vue'),
                meta: {
                    requireAuth: true
                }
            },
        ]
    },

    {
        path: '',
        component: () => import("../layouts/BlankLayout.vue"),
        children: [
            {
                path: '/Auth/Login',
                name: 'authLogin',
                component: () => import('@/modules/authLogin/loginTemplate.vue'),
                meta: {
                    requireAuth: false
                }
            },
            {
                path: '/:catchAll(.*)',
                name: 'NotFound',
                component: () => import('@/core/pagesErrors/404Template.vue'),
                meta: {
                    requireAuth: false
                }
            },
            {
                path: '/error',
                name: 'ServerError',
                component: () => import('@/core/pagesErrors/500Template.vue'),
                meta: {
                    requireAuth: false
                }
            }
        ]
    },

]

const router = createRouter({ history: createWebHistory(), routes })

router.beforeEach((to,from,next)=>{
    const auth= useAuthorization();
    const isAuth= auth.statusLogin
    if((to.meta.requireAuth) && (isAuth==false)){
        next('/Auth/Login');
    } else if (to.path === '/Auth/Login' && isAuth) {
        next('/');
    } else{
        next();
    }
})
export default router